<template>
  <v-container grid-list-xl class="pa-0" v-if="dokumen">
    <m-breadcrum class="mt-5 mb-0" :items="bread"></m-breadcrum>
    <m-card title="Rekap Dokumen Kota" download @download="toDowload">
      <div class="py-2 mt-4 mb-4">
        <m-button dark color="amber" small depreed textButton="Unduh SK" action="toSK" @toSK="toSK"></m-button>
      </div>
      <v-simple-table id="rekap">
        <template v-slot:default>
          <thead>
            <tr>
              <th>No</th>
              <th>Kecamatan</th>
              <th>Jumlah</th>
              <th>SK Pengurus</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, index) in dokumen" :key="item.index">
              <td class="text-center">{{ index + 1 }}</td>
              <td>
                <!-- <router-link
                  class="primary--text font-weight-bold"
                  :to="{
                    name: 'dokumen.kecamatan',
                    params: {
                      propinsi_id: item.propinsi_id,
                      kota_id: item.kota_id,
                      kecamatan_id: item.id
                    }
                  }"
                  >{{ pVal(item, "kecamatan") }}
                </router-link> -->
                {{ pVal(item, "kecamatan") }}
              </td>
              <td class="text-center">{{ item.jumlah }}</td>
              <td class="text-center">
                <v-icon :color="item[301] === 'sudah' ? 'success' : 'error'">{{ item[301] === "sudah" ? "mdi-check" : "mdi-close" }}</v-icon>
              </td>
            </tr>
          </tbody>
          <!-- <tfoot class="grey lighten-1">
            <td colspan="2" class="text-center font-weight-bold">Total</td>
            <td class="text-center font-weight-bold">{{ dokumen.total }}</td>
          </tfoot> -->
        </template>
      </v-simple-table>
    </m-card>
  </v-container>
</template>

<script>
const lc = window.localStorage;
const TOKEN = "siapbbjatimtoken";
import MChartPie from "@/components/MChartPie";
import BlockCard from "@/components/BlockCard";

export default {
  components: {
    MChartPie,
    BlockCard
  },
  data() {
    return {
      gender: {
        legend: [],
        data: []
      },
      jenis_anggota: {
        legend: [],
        data: []
      },
      usia: {
        legend: [],
        data: []
      },
      dokumen: {
        list: []
      },
      countWarga: 0,
      propinsi_ket: "",
      kota_ket: "",
      kota: null
    };
  },
  mounted() {
    this.countWarga = 0;
    this.load();
    this.loadKeteranganPropinsi();
    this.loadKeteranganKota();
    // this.loadStatistik();
  },
  methods: {
    load() {
      var token = lc.getItem(TOKEN);
      return this.$store
        .dispatch("dokumen/rekapKota", {
          params: {
            kota_id: this.kota_id,
            access_token: token
          }
        })
        .then(res => {
          this.dokumen = res;
        })
        .catch(e => e);
    },
    loadStatistik() {
      this.$store
        .dispatch("dokumen/statistikKota", {
          params: { kota_id: this.kota_id }
        })
        .then(res => {
          this.gender.legend = ["L : " + res.kelamin.pria, "P : " + res.kelamin.wanita];
          this.gender.data = [
            {
              value: res.kelamin.pria,
              name: "L : " + res.kelamin.pria
            },
            {
              value: res.kelamin.wanita,
              name: "P : " + res.kelamin.wanita
            }
          ];
          this.jenis_anggota.legend = [
            "Anggota : " + res.jenis_anggota.Anggota,
            "Ranting : " + res.jenis_anggota.Ranting,
            "PAC : " + res.jenis_anggota.PAC,
            "DPC : " + res.jenis_anggota.DPC,
            "DPW : " + res.jenis_anggota.DPW,
            "DPP : " + res.jenis_anggota.DPP
          ];
          this.jenis_anggota.data = [
            {
              value: res.jenis_anggota.Anggota,
              name: "Anggota : " + res.jenis_anggota.Anggota
            },
            {
              value: res.jenis_anggota.Ranting,
              name: "Ranting : " + res.jenis_anggota.Ranting
            },
            {
              value: res.jenis_anggota.PAC,
              name: "PAC : " + res.jenis_anggota.PAC
            },
            {
              value: res.jenis_anggota.DPC,
              name: "DPC : " + res.jenis_anggota.DPC
            },
            {
              value: res.jenis_anggota.DPW,
              name: "DPW : " + res.jenis_anggota.DPW
            },
            {
              value: res.jenis_anggota.DPP,
              name: "DPP : " + res.jenis_anggota.DPP
            }
          ];
          this.usia.legend = ["0-25 Thn : " + res.usia.usia_0_sampai_25_tahun, "26-40 Thn : " + res.usia.usia_26_sampai_40_tahun, ">40 Thn : " + res.usia.usia_lebih_40_tahun];
          this.usia.data = [
            {
              value: res.usia.usia_0_sampai_25_tahun,
              name: "0-25 Thn : " + res.usia.usia_0_sampai_25_tahun
            },
            {
              value: res.usia.usia_26_sampai_40_tahun,
              name: "26-40 Thn : " + res.usia.usia_26_sampai_40_tahun
            },
            {
              value: res.usia.usia_lebih_40_tahun,
              name: ">40 Thn : " + res.usia.usia_lebih_40_tahun
            }
          ];
        });
    },
    loadKeteranganPropinsi() {
      return this.$store
        .dispatch("dokumen/keteranganPropinsi", this.propinsi_id)
        .then(res => {
          this.propinsi_ket = res.keterangan;
          this.propinsi = res;
        })
        .catch(e => e);
    },
    loadKeteranganKota() {
      return this.$store
        .dispatch("dokumen/keteranganKota", this.kota_id)
        .then(res => {
          this.kota_ket = res.keterangan;
          this.kota = res;
        })
        .catch(e => e);
    },
    toDowload() {
      var token = lc.getItem(TOKEN);

      return this.$store
        .dispatch("dokumen/downloadRekapKota", {
          token: token,
          params: {
            propinsi_id: this.propinsi_id,
            kota_id: this.kota_id,
            kecamatan_id: this.kecamatan_id,
            is_download: 1,
            access_token: token
          }
        })
        .catch(e => e);
    },
    toSK() {
      var token = lc.getItem(TOKEN);

      return this.$store
        .dispatch("dokumen/downloadRekapKotaSK", {
          token: token,
          params: {
            propinsi_id: this.propinsi_id,
            kota_id: this.kota_id,
            kecamatan_id: this.kecamatan_id,
            is_download: 1,
            access_token: token
          }
        })
        .catch(e => e);
    }
  },
  watch: {
    propinsi_id(p) {
      this.loadKeteranganPropinsi(p);
    },
    kota_id(n) {
      this.loadKeteranganKota(n);
      if (n) {
        this.load();
        this.loadStatistik();
      }
    }
  },
  computed: {
    bread() {
      return [
        {
          icon: "mdi-library-books",
          title: "Rekap Pusat",
          to: this.current_user.lingkup.tingkat == 1 ? { name: "dokumen.pusat" } : null
        },
        {
          icon: "mdi-library-books",
          to:
            this.current_user.lingkup.tingkat == 1 || this.current_user.lingkup.tingkat == 2
              ? {
                  name: "dokumen.propinsi",
                  params: { propinsi_id: this.propinsi_id }
                }
              : null,
          title: this.propinsi_ket
        },
        {
          icon: "mdi-library-books",
          title: this.kota_ket
        }
      ];
    }
  }
};
</script>
<style>
#rekap {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#rekap td,
#rekap th {
  border: 1px solid #ddd;
  padding: 8px;
}

#rekap tr:nth-child(even) {
  background-color: #f2f2f2;
}

#rekap tr:hover {
  background-color: #ddd;
}

#rekap th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  background-color: #4caf50;
  color: white;
}
</style>
